<script>
import {
  shippingMethodClickAndCollectTraiteurProps,
  useShippingMethodClickAndCollectTraiteur
} from "./mixin";
import Planning from "@/containers/planning";
import Card from "@/components/molecules/card";

export default {
  name: "ShippingMethodClickCollectTraiteur",
  components: {
    Planning,
    Card
  },
  props: {
    ...shippingMethodClickAndCollectTraiteurProps()
  },
  setup(props) {
    const { serviceModel, serviceSelected, resetService } =
      useShippingMethodClickAndCollectTraiteur(props);

    return {
      serviceModel,
      serviceSelected,
      resetService
    };
  }
};
</script>

<template>
  <div class="u-pt-sm u-pl-md u-pr-md u-pb-md">
    <Card
      variant="grey-7"
      class="u-p-sm"
    >
      <h2 class="u-font-18 u-mr-lg u-mb-sm">
        Votre point de retrait
      </h2>
      <div class="u-ml-sm">
        <p class="u-font-15">
          <strong class="u-mr-sm">{{ serviceModel.description }}</strong>
        </p>
        <p class="u-font-15 u-mb-sm">
          {{ serviceModel.adresse }}
          <br>
          {{ serviceModel.details }}
        </p>
      </div>
    </Card>
    <p class="u-font-14 u-mt-md u-mb-lg u-ml-md">
      Merci de préciser le créneau horaire auquel vous souhaitez retirer vos produits
    </p>
    <Planning
      :service-id="serviceModel.id"
      :infos-legales="serviceModel.info_non_retrait"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/schedule.scss";
</style>
